import { render, staticRenderFns } from "./SeleccionActivos.vue?vue&type=template&id=5c58f1c2&"
import script from "./SeleccionActivos.vue?vue&type=script&lang=js&"
export * from "./SeleccionActivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports